import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHamburgerMenu = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 15,
	viewBox: "0 0 18 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M16.8125 12.8125C17.3203 12.8125 17.75 13.2422 17.75 13.75C17.75 14.2969 17.3203 14.6875 16.8125 14.6875H1.1875C0.640625 14.6875 0.25 14.2969 0.25 13.75C0.25 13.2422 0.640625 12.8125 1.1875 12.8125H16.8125ZM16.8125 0.3125C17.3203 0.3125 17.75 0.742188 17.75 1.25C17.75 1.79688 17.3203 2.1875 16.8125 2.1875H1.1875C0.640625 2.1875 0.25 1.79688 0.25 1.25C0.25 0.742188 0.640625 0.3125 1.1875 0.3125H16.8125ZM16.8125 6.5625C17.3203 6.5625 17.75 6.99219 17.75 7.5C17.75 8.04688 17.3203 8.4375 16.8125 8.4375H1.1875C0.640625 8.4375 0.25 8.04688 0.25 7.5C0.25 6.99219 0.640625 6.5625 1.1875 6.5625H16.8125Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgHamburgerMenu);
export { ForwardRef as ReactComponent };
